import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "placeholder"]
const _hoisted_2 = ["disabled"]

import { computed } from 'vue';
import type { OperationInfo } from '@/types/v2/task/animal-transfer/operation.types';

interface Props {
    modelValue: number;
    transferInfo?: OperationInfo;
    performOperation: () => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TransferInput',
  props: {
    modelValue: { default: 0 },
    transferInfo: { default: undefined },
    performOperation: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const actionText = computed(() => {
    const actions = props.transferInfo?.action.upper;
    return actions ? actions[actions.length - 1] : 'Transfer';
});

const placeholderText = computed(() =>
    `${actionText.value} amount`
);

const isDisabled = computed(() => props.modelValue === 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      type: "number",
      value: _ctx.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', +($event.target as HTMLInputElement).value))),
      class: "border border-primary text-center text-xl w-full p-2 rounded mb-2",
      placeholder: placeholderText.value
    }, null, 40, _hoisted_1),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.performOperation && _ctx.performOperation(...args))),
      class: "w-full text-xl rounded bg-primary px-4 py-2 text-white border border-white",
      disabled: isDisabled.value
    }, _toDisplayString(actionText.value) + " fish ", 9, _hoisted_2)
  ]))
}
}

})